import styled from '@emotion/styled';
import Close from '~/icons/close.svg';
import Button, { StyledButton } from '../../shared/components/Button';

export const Content = styled.div({
    height: '100%',
});

export const Container = styled.div(({ theme }) => ({
    padding: `0 ${theme.metrics.xsmall}`,
    overflow: 'auto',
    maxHeight: `calc(100vh - ${theme.metrics.xlarge} - ${theme.metrics.large})`,
    '> *': {
        marginTop: theme.space[3],
    },
}));

export const StyledHeader = styled.div(({ theme }) => ({
    height: `${theme.metrics.xlarge}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: `0 2px 20px 0 rgba(0,0,0,0.2)`,
    padding: '10px',
}));

export const StyledFooter = styled.div(({ theme }) => ({
    alignItems: 'center',
    justifyContent: 'center',
    padding: `0 ${theme.metrics.micro}`,
}));

export const StyledTitle = styled.p(({ theme }) => ({
    display: 'flex',
    height: `${theme.metrics.xlarge}`,
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    ...theme.mixins.useTextStyle('InfoHeader'),
}));

export const CloseButton = styled(Button)(({ theme }) => ({
    svg: {
        height: `${theme.fontSizes.sm}`,
        width: `${theme.fontSizes.sm}`,
    },
}));
export const StyledClose = styled(Close)({});

export const StyledCTAButton = styled(StyledButton)(({ theme }) => ({
    width: '100%',
    height: `${theme.metrics.medium}`,
    marginTop: '20px',
    textTransform: 'uppercase',
}));

export const StyledSocialButton = styled(StyledButton)(({ theme }) => ({
    marginTop: '8px',
    width: '100%',
    height: `${theme.metrics.medium}`,
    border: `solid 1px ${theme.colors.black}`,
    textTransform: 'uppercase',
    color: theme.colors.black,
    svg: {
        path: {
            fill: 'currentcolor',
        },
    },
}));
export const StyledForgotPasswordLink = styled.a(({ theme }) => ({
    float: 'right',
    marginTop: '6px',
    color: theme.colors.black,
    fontSize: theme.fontSizes['xs'],
}));

export const StyledLoginH4 = styled.h4(({ theme }) => ({
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'center',
    marginBottom: '15px',
    color: theme.colors.black,
}));
export const StyledLoginTextblock = styled.p(({ theme }) => ({
    marginLeft: 'auto',
    marginRight: 'auto',
    textAlign: 'center',
    marginBottom: '20px',
    color: theme.colors.black,
    fontSize: theme.fontSizes['xs'],
}));
export const StyledLoginSignupWrapper = styled.div(({ theme }) => ({
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '92%',
    height: '50px',
    borderRadius: '25px',
    border: `1px solid ${theme.colors.brownLight}`,
    overflow: 'hidden',
    ':focus-visible': {
        boxShadow: theme.shadows.accessibility,
    },
}));

export const StyledSignupButton = styled.div(({ theme }) => ({
    width: '50%',
    height: '48px',
    color: theme.colors.black,
    textAlign: 'center',
    float: 'right',
    paddingTop: '15px',
    textTransform: 'uppercase',
}));

export const StyledLoginSignupButtonActive = styled.div(({ theme }) => ({
    width: '100%',
    height: '48px',
    borderRadius: '25px',
    backgroundColor: theme.colors.black,
    color: theme.colors.white,
    textAlign: 'center',
    paddingTop: '15px',
    textTransform: 'uppercase',
}));

export const StyledLoginSignupButtonInactive = styled.div(({ theme }) => ({
    width: '100%',
    height: '48px',
    color: theme.colors.black,
    textAlign: 'center',
    paddingTop: '15px',
    textTransform: 'uppercase',
    cursor: 'pointer',
    ':hover': {
        borderRadius: '25px',
        backgroundColor: theme.colors.grey20,
        color: theme.colors.black,
    },
}));

export const CheckboxLabel = styled.span(({ theme }) => ({
    color: theme.colors.black,
    fontSize: theme.fontSizes['xs'],
}));
